export default __webpack_public_path__ + "static/media/48_desktop.4435527e.jpg";